import React from 'react';
import { Link } from 'react-router-dom';
import { NAV } from '@/constants/testIds';

const WORDMARK = `${process.env.PUBLIC_URL || ''}/logo-wordmark-dark.svg`;

export const Logo = ({ className = '', heightClass = 'h-7' }) => (
  <Link
    to="/"
    data-testid={NAV.logo}
    aria-label="Copy.Click home"
    className={`inline-flex items-center transition-opacity hover:opacity-80 ${className}`}
  >
    <img src={WORDMARK} alt="Copy.Click" className={`${heightClass} w-auto`} draggable="false" />
  </Link>
);
